interface EnergyClassificationProps {
    letter: string;
    color?: string;
}

export const EnergyClassification = ({ letter, color = '#A9A9A9' }: EnergyClassificationProps) => (
    <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M12.6682 5.11719C12.8557 4.96094 13.1369 4.96094 13.3244 5.11719L21.8244 12.6172C22.0432 12.8047 22.0432 13.1172 21.8869 13.3359C21.6994 13.5547 21.3869 13.5547 21.1682 13.3672L20.0119 12.3359V18.4922C20.0119 19.8984 18.8869 20.9922 17.5119 20.9922H8.51194C7.10569 20.9922 6.01194 19.8984 6.01194 18.4922V12.3359L4.82444 13.3672C4.63694 13.5547 4.29319 13.5547 4.13694 13.3359C3.94944 13.1172 3.94944 12.8047 4.16819 12.6172L12.6682 5.11719ZM7.01194 11.4609V18.4922C7.01194 19.3359 7.66819 19.9922 8.51194 19.9922H17.5119C18.3244 19.9922 19.0119 19.3359 19.0119 18.4922V11.4609L13.0119 6.17969L7.01194 11.4609Z"
            fill={color}
        />
        <text x="13" y="18" textAnchor="middle" fill={color} fontSize="10" fontWeight="500">
            {letter}
        </text>
    </svg>
);
